import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import router from "@/router";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import "./assets/tailwind.min.css";
import { useUserStore } from "./store";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const userStore = useUserStore();
const { user } = storeToRefs(userStore);

/** Set locale */
const { locale } = useI18n({
  useScope: "global",
});

locale.value = "en";

onMounted(async () => {
  try {
    await userStore.fetchUser();

    if (user.value.id && !user.value.has_onboarded) {
      return router.push("/dashboard/onboarding");
    }

    if (user.value.id) {
      return;
    }
  } catch (e) {
    console.log(e);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }))
}
}

})